module.exports = __webpack_public_path__ + "media/AUDIO 06.2831de5b.mp3";